import { Component, inject } from '@angular/core';
import { OrdersService } from 'src/app/services/orders.service';
import { Order } from 'src/app/models/order.model'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrdersTemplatedListComponent } from '../orders-templated-list/orders-templated-list.component';

@Component({
    selector: 'app-account-orders',
    templateUrl: './account-orders.component.html',
    styleUrls: ['./account-orders.component.css'],
    imports: [OrdersTemplatedListComponent]
})
export class AccountOrdersComponent {

  private orders = inject(OrdersService);

  listOrders: Array<Order> = [];

  constructor() {
    this.orders.ordersObservable
      .pipe(takeUntilDestroyed())
      .subscribe(
        (next: Array<Order>) => {
          this.listOrders = next;
        }
      )

    this.orders.getOrders()
  }

}
